module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_mascarenhas_sm-afc7bded1c60134166e3cb429c06dee4.png";